<template>
  <div class="mainview ">
    <div class="view contentBody">
      <!-- <div class="title">客户列表</div> -->
     
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item label="部门">
              <span class="choosedep" v-if="departmentName">{{departmentName}}</span>
              <el-button @click="choosedep" size="small">选择部门</el-button>
            </el-form-item>
            <el-form-item label="用户昵称">
              <el-input class="w160" v-model="formdata.name" size="small"></el-input>
            </el-form-item>
            <el-form-item label="来源">
              <el-select v-model="formdata.type" placeholder="请选择" size="small">
                <el-option
                        v-for="item in customerTypeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="点击次数">
              <el-input v-model="formdata.min" class="w80" size="small"></el-input>
              -
              <el-input v-model="formdata.max" class="w80" size="small"></el-input>
            </el-form-item>
            <el-form-item label="最后访问时间">
              <el-date-picker
                      v-model="timeData"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      size="small"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" @click="searchcustomer"></el-button>
              <el-button type="primary" size="small" @click="exportfile">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <!--<el-table-column prop label type="selection"></el-table-column>-->
          <el-table-column label="头像" width="80">
            <template slot-scope="scope">
              <img class="whd-block" :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
              <img class="whd-block" src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="微信昵称"></el-table-column>
          <!--<el-table-column prop="address" label="备注名"></el-table-column>-->
          <el-table-column prop="mobile" label="授权电话"></el-table-column>
          <el-table-column prop="name" label="跟进人"></el-table-column>
          <el-table-column prop="department" label="所属部门"></el-table-column>
          <el-table-column prop="click" label="点击次数"></el-table-column>
          <el-table-column prop="type" label="来源"></el-table-column>
          <el-table-column prop="create_time" label="首次访问时间"></el-table-column>
          <el-table-column prop="update_time" label="最后访问时间"></el-table-column>
          <el-table-column label="其他联络人">
            <template slot-scope="scope">
              <span class="tablelineUser">{{scope.row.others}}</span>
              <el-popover
                      placement="left-start"
                      :title="scope.row.others_obj.title"
                      trigger="hover">
                <div class="tableline" v-if="scope.row.others_obj.all_list.length">
                  <p class="list" v-for="(item,index) in scope.row.others_obj.all_list" :key="index">
                    <span>{{item.name}}</span>
                    <span>{{item.position}}</span>
                    <span>{{item.company}}</span>
                  </p>
                </div>
                <span slot="reference" class="tablelineBtn">{{scope.row.others_link_str}}</span>
              </el-popover>
              <!--<span style="display: block">{{scope.row.others_link_str}}</span>-->
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <span @click="onShowIntegral(scope.row.uid)" class="action_btn">派发积分</span>
              <span @click="chooseadviser(scope.row)" class="action_btn">设置专属顾问</span>
              <span @click="customdetail(scope.row)" class="action_btn">详情</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
                  background
                  @current-change="pageIndexChange"
                  :page-size="page.pagesize"
                  :current-page="page.pageindex"
                  layout="total, prev, pager, next"
                  :total="page.total"></el-pagination>
        </div>
      </div>
    </div>
    <chooseDepDialog
            :visible.sync="choosedepdialog"
            v-if="choosedepdialog"
            @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
    <customDetailDialog :visible.sync="customdetaildialog" v-if="customdetaildialog"></customDetailDialog>
    <!--<chooseAdviserDialog :visible.sync="chooseadviserdialog" v-if="chooseadviserdialog"></chooseAdviserDialog>-->
    <chooseManagerDialog
            :visible.sync="chooseadviserdialog"
            @userDetail="userDetail"
            @updata="querycustom"
            v-if="chooseadviserdialog"
            :typeDialog="typeDialog"
    ></chooseManagerDialog>
    <integralDialog v-if="showIntegral" :visible.sync="showIntegral" :vid="visitor_id" :phone="phone"></integralDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import {pagination, customerType} from "@/util/util.js";
  import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
  import customDetailDialog from "@/components/dialog/customDetailDialog.vue";
  import chooseAdviserDialog from "@/components/dialog/chooseAdviserDialog.vue";
  import chooseManagerDialog from "@/components/dialog/chooseManagerDialog.vue";
  import integralDialog from "@/components/dialog/integralDialog.vue";

  export default {
    name: "visitorList",
    components: {
      chooseDepDialog,
      customDetailDialog,
      chooseAdviserDialog,
      chooseManagerDialog,
      integralDialog
    },
    data() {
      return {
        typeDialog: 4,
        // page 	整型 	必填 	- 	- 	页码
        // name 	整型 	必填 	- 	- 	员工名称搜索
        // depart_id 	整型 	必填 	- 	- 	部门id
        // min 	整型 	非必填 	- 	- 	最小点击次数
        // max 	整型 	非必填 	- 	- 	最大点击次数
        // start_time 	整型 	非必填 	- 	- 	开始日期(最后访问时间)
        // end_time 	整型 	非必填 	- 	- 	结束日期(最后访问时间)
        formdata: {
          page: 1, // 	整型 	必填 	- 	- 	页码
          name: '', // 	整型 	必填 	- 	- 	员工名称搜索
          depart_id: '', // 	整型 	必填 	- 	- 	部门id
          min: '',
          max: '',
          start_time: '',
          end_time: '',
          type: ''
        },
        timeData: [],
        options: [],
        tableData: [],
        departmentName: '',
        customerTypeOption: customerType,
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        choosedepdialog: false,
        customdetaildialog: false,
        chooseadviserdialog: false,
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
          },
        },
        uid: "",
        showIntegral: '',
        visitor_id: '',
        phone: ''
      };
    },
    created() {
      this.init();
      this.axios
          .post(api.distribution_judge, {})
          .then(response => {
            if (response.data.code == 0) {
              this.phone = response.data.info.phone;
            } 
          })
          .catch(() => {});
    },
    methods: {
      //初始化请求
      init() {
        this.querycustom();
      },
      // 查询
      querycustom() {
        // page 	整型 	必填 	- 	- 	页码
        // name 	整型 	必填 	- 	- 	员工名称搜索
        // depart_id 	整型 	必填 	- 	- 	部门id
        // min 	整型 	非必填 	- 	- 	最小点击次数
        // max 	整型 	非必填 	- 	- 	最大点击次数
        // start_time 	整型 	非必填 	- 	- 	开始日期(最后访问时间)
        // end_time 	整型 	非必填 	- 	- 	结束日期(最后访问时间)
        this.formdata.page = this.page.pageindex
        if (this.timeData && this.timeData.length > 0) {
          this.formdata.start_time = this.timeData[0]
          this.formdata.end_time = this.timeData[1]
        } else {
          this.formdata.start_time = ""
          this.formdata.end_time = ""
        }
        this.axios
            .post(api.customer_visitor, this.formdata)
            .then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.list;
                this.page.total = response.data.all_page;
              } else {
                this.page.total = 0;
              }
            })
            .catch(response => {
            });
      },
      searchcustomer() {
        this.page.pageindex = 1
        this.querycustom()
      },
      // 选择部门
      choosedep() {
        this.choosedepdialog = true;
      }, 
      choosedepsucess(val) {
        this.departmentName = val.name;
        this.formdata.depart_id = val.id;
        this.init();
      },
      // 详情
      customdetail() {
        this.customdetaildialog = true;
      },
      // 顾问
      chooseadviser(option) {
        this.uid = option.uid;
        this.chooseadviserdialog = true;
      },
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.querycustom();
      },
      userDetail(option) {
        // console.log('获取顾问信息', option)
        this.axios.post(api.customer_setCounselor, {
          employee_id: option.id,
          uid: this.uid
        })
          .then(response => {
            if (response.data.code == 0) {
              this.$message.success('设置成功');
              this.chooseadviserdialog = false;
              this.querycustom();
            } 
          })
          .catch(response => {
          });          
      },
     
      // 导出
      exportfile() {
        this.axios.get(this.tabIndex==0?api.companyadmin_Customer_out_excel:api.companyadmin_Customer_out_excel_visitor,{
          params:this.formdata,
          responseType: "arraybuffer"
        })
        .then(
            function(response) {
              let filename = this.tabIndex==0?"客户列表.xlsx":"访客列表.xlsx";
              this.fileDownload(response.data, filename);
            }.bind(this)
        )
        .catch(
            function(error) {
              // console.log("网络请求出错",error);
            }.bind(this)
        );
      },
      fileDownload (data, fileName) {
        let blob = new Blob([data], {
          type: "application/octet-stream"
        });
        let filename = fileName || "filename.xls";
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          let blobURL = window.URL.createObjectURL(blob);
          let tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", filename);
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }
      },
      onShowIntegral(option) {
        this.visitor_id = option;
        this.showIntegral = true;
      }
    }
  };
</script>

<style scoped>
.form-inline .el-form-item{margin-right: 20px;}
</style>